<template>
<section>
  <notifications></notifications>
  <router-view></router-view>
</section>
</template>

<script>
  import { API, Auth } from './api'
  import Vue from 'vue'

  Vue.prototype.$API = API;

  export default {
    watch:{
    $route (){
        this.$store.state.search = '';
      },
    },
    methods: {
      handleAPIErrors() {
        this.$API.interceptors.response.use((response) => {
          if (response.data && response.data.error) {
            this.notify(response.data.error);
            throw new Error(response.data.error);
          }

          return response;
        }, (err) => {

          return new Promise((resolve, reject) => {
            if (err.response && err.config && !err.config.__isRetryRequest) {
              if (err.response.status === 401) {
                // if you ever get an unauthorized, logout the user
                Auth.logout(this.$API);
                this.$router.push('/auth');
              }
              else if (err.response.status === 403) {
                this.$router.push('/forbidden');
              }
              else if (err.response.data && err.response.data.error) {
                this.notify(err.response.data.error);
                reject();
              }
              else {
                reject();
              }
            }
          });
        });
      },
      notify (message) {
        this.$notify({ type: 'danger', message });
      }
    },
    created: function () {
      if (Auth.isAuthenticated) {
        Auth.setApiToken(this.$API);
      }
      this.handleAPIErrors();
      if (window.innerWidth <= 780) {
        this.$store.commit("mobileSettings",this.$route.name)
      }
    }
  }
</script>

<style lang="scss">
@import "../node_modules/vue-notifyjs/themes/default.css";
@import '../node_modules/select2/dist/css/select2.css';
@import './styles/select2.scss';
@import './styles/scrollbar.scss';
@import './styles/notifications.scss';

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.mb-1 {
  margin-bottom: 5px;
}

.mb-2 {
  margin-bottom: 10px;
}

.mb-3 {
  margin-bottom: 15px;
}

.mb-4 {
  margin-bottom: 20px;
}

.mt-1 {
  margin-top: 5px;
}

.mt-2 {
  margin-top: 10px;
}

.mt-3 {
  margin-top: 15px;
}

.mt-4 {
  margin-top: 20px;
}

.ml-1 {
  margin-left: 5px;
}

.ml-2 {
  margin-left: 10px;
}

.ml-3 {
  margin-left: 15px;
}

.ml-4 {
  margin-left: 20px;
}

.mr-1 {
  margin-right: 5px;
}

.mr-2 {
  margin-right: 10px;
}

.mr-3 {
  margin-right: 15px;
}

.mr-4 {
  margin-right: 20px;
}

.w-100 {
  width: 100%;
}

.flex-sb-adaptive {
  display: flex;
  justify-content: space-between;

  > *:not(:last-of-type) {
    margin-right: 25px;
  }

  @media (max-width: 900px) {
    flex-direction: column;

    > * {
      margin-right: 0;
    }
  }
}
</style>
